import React, { Component } from 'react';

import './Logo.css';
import { getLogoDataAsync, getStoreId } from '../../utils/StoreConfigManager.js';
import { LogoClicked } from '../../utils/Analytics.js';
import { constructUrl } from '../../utils/UrlConstructor.js';
import InteractableElement from './InteractableElement';
import BaseImage from './image-components/BaseImage';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';

const isMobile = isMobileDevice();
const style = {
    width: '68px',
    height: '20px'
};

const storeId = getStoreId();

export const singaporeStoreId = '620d286ec38181ef4d34fbfb';

class Logo extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.state = {
            imageSrc: '',
            redirectUrl: ''
        };
        getLogoDataAsync()
            .then((logoData) => {
                const imageSrcObject = logoData['imageSrc'];
                const redirectUrlObject = logoData['redirectUrl'];
                const imageSrc = imageSrcObject ? constructUrl(imageSrcObject) : '';
                const redirectUrl = redirectUrlObject ? constructUrl(redirectUrlObject) : '';

                this.setState({
                    imageSrc: imageSrc,
                    redirectUrl: redirectUrl
                });
            })
            .catch(error => console.error(error));
    }

    onClick() {
        LogoClicked();
        window.open(this.state.redirectUrl, '_blank');
    }

    render() {
        const imageSrc = this.state.imageSrc;
        if (!imageSrc) {
            return <React.Fragment />
        }
        return (
            <div id='topLeftLogo' className='hoverable'>
                <InteractableElement onClick={this.onClick}>
                    <BaseImage
                        src={imageSrc}
                        style={style}
                    />
                </InteractableElement>
                <span className="street-title">{storeId === singaporeStoreId ? 'MARINA BAY SANDS' : '57TH STREET'}</span>
            </div>
        );
    }
}

export default Logo;
